import {z} from 'zod'

import {isMultiple} from '../../../utils/math'
import {Fields, RangeSettings} from '../types'

import {ErrorCodes} from './errorCodes'

export const validateFieldRange = (
  value: number,
  settings: RangeSettings,
  field: Fields,
  path: string,
  ctx: z.RefinementCtx
) => {
  if (value < settings.min || value > settings.max) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: [path],
      message: ErrorCodes[field].outOfRange
    })
  }

  if (!isMultiple(value, settings.step)) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: [path],
      message: ErrorCodes[field].invalidStep
    })
  }
}
